import Icon from '../components/Icon.vue'

Icon.register({
  'times-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM377.6 321.1l-65.6-65.1 65.7-65c4.7-4.7 4.7-12.3 0-17l-39.6-39.6c-4.7-4.7-12.3-4.7-17 0l-65.1 65.6-65-65.7c-4.7-4.7-12.3-4.7-17 0l-39.6 39.6c-4.7 4.7-4.7 12.3 0 17l65.6 65.1-65.6 65c-4.7 4.7-4.7 12.3 0 17l39.5 39.6c4.7 4.7 12.3 4.7 17 0l65.1-65.6 65 65.6c4.7 4.7 12.3 4.7 17 0l39.6-39.5c4.7-4.7 4.7-12.3 0-17z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/times-circle.js
// module id = 2010
// module chunks = 0